<template>
  <div class="base_box roll">
    <div class="chart_list">
      <!-- 数据基于本站收录的妈祖庙 -->
      <p>{{$t("chart.t1")}}</p>
      <div class="chart_box">
        <ChartLines :templeDate="templeDate" class="chart_card"> </ChartLines>
      </div>
      <!-- <div class="chart_box">
        <ChartTest class="chart_card"> </ChartTest>
      </div> -->
      <div class="chart_box">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <ChartDynastyBar :templeDate="dynasty" class="chart_card"></ChartDynastyBar>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <ChartDynastyCir :templeDate="dynasty" class="chart_card"> </ChartDynastyCir>
          </el-col>
        </el-row>
      </div>

      <div class="chart_box">
        <ChartAreaBar class="chart_card"> </ChartAreaBar>
      </div>
      <!-- <div class="chart_box">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <ChartAreaBar class="chart_card"> </ChartAreaBar>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <ChartAreaCir class="chart_card"> </ChartAreaCir>
          </el-col>
        </el-row>
      </div> -->

    </div>
  </div>
</template>

<script>
import ChartAreaBar from "../../components/charts/ChartAreaBar.vue";
// import ChartAreaCir from "../../components/charts/ChartAreaCir.vue";
import ChartDynastyBar from "../../components/charts/ChartDynastyBar.vue";
import ChartDynastyCir from "../../components/charts/ChartDynastyCir.vue";
import ChartLines from "../../components/charts/ChartLines.vue";
// import ChartTest from "../../components/charts/ChartTest.vue";
export default {
  name: "Chart",
  components: {
    ChartAreaBar,
    // ChartAreaCir,
    ChartDynastyBar,
    ChartDynastyCir,
    ChartLines,
    // ChartTest,
  },
  data() {
    return {
      templeDate: null,
      templeNum: 0,
      years: null, //时间分类
      dynasty: {}, //朝代分类
    };
  },
  created() {},
  mounted() {
    this.getTempleList();
  },
  methods: {
    //获取庙宇列表
    getTempleList() {
      let temple = this.$store.state.temple.templeData;
      if (temple.length > 0) {
        this.templeDate = temple;
        this.dynasty = this.common.dynastyCale(temple);
        this.templeNum = temple.length;
      } else {
        this.$Loading.show();
        let pardata = { state: "1" };
        this.http.post("temple/getTempleList", pardata).then((res) => {
          if (res.code == "0") {
            this.$Loading.hide();
            this.$store.state.temple.templeData = res.data;
            this.templeDate = res.data;
            this.dynasty = this.common.dynastyCale(res.data);
            this.templeNum = res.data.length;
            // this.$message({
            //   message: "获取庙宇图表数据成功",
            //   type: "success",
            // });
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.base_box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding-top: $head-height;
  box-sizing: border-box;
  .chart_list {
    padding: $m-mid $m-hug;
    margin: 0 auto;
    .chart_box {
      .chart_card {
        height: 25rem;
        width: 100%;
        border-radius: $r-big;
        box-shadow: $shadow;
        margin: $m-lit auto;
        padding: $m-lit;
        padding-top: $m-mid;
        background-color: $c-white;
      }
    }
  }
}
</style>